module.exports = __webpack_public_path__ + "img/75634.0fb1ec3b.svg";